import { inject, Injectable } from "@angular/core";
import { AnswerGroupCategoryType, CreateMacroSectionsGQL, CreateMacroSectionsMutation, CreateQuestionRequest, CreateQuestionsGQL, CreateQuestionsMutation, DeleteMacroSectionsGQL, DeleteMacroSectionsMutation, DeleteQuestionsGQL, DeleteQuestionsMutation, InputMaybe, MacroSectionInput, MacroSectionListInput, MacroSectionQueryResponse, UpdateSectionTitleGQL, UpdateSectionTitleMutation } from "../../../graphql/generated";
import { map, Observable } from "rxjs";
import { MAP_QUESTION_GROUP, SaveEvent } from "../shared/models/qualitative.model";
import { QuestionSections } from "../shared/components/questionnaire.component";

@Injectable({
    providedIn: "root"
})
export class QualitativeService {
    private readonly UpdateSectionTitleGQL: UpdateSectionTitleGQL = inject(UpdateSectionTitleGQL);
    private readonly DeleteQuestionsGQL: DeleteQuestionsGQL = inject(DeleteQuestionsGQL);
    private readonly DeleteMacroSectionsGQL: DeleteMacroSectionsGQL = inject(DeleteMacroSectionsGQL);
    private readonly CreateQuestionsGQL: CreateQuestionsGQL = inject(CreateQuestionsGQL);
    private readonly CreateMacroSectionsGQL: CreateMacroSectionsGQL = inject(CreateMacroSectionsGQL);


    updateSectionTitle(sections: MacroSectionListInput[]): Observable<UpdateSectionTitleMutation['updateMacroSection']> {
        return this.UpdateSectionTitleGQL.mutate(
            {
                input: sections
            }, {
            fetchPolicy: 'no-cache'
        }).pipe(map(result => result.data?.updateMacroSection));
    }

    deleteQuestions(ids: string[]): Observable<DeleteQuestionsMutation['deleteQuestions']> {
        return this.DeleteQuestionsGQL.mutate(
            {
                ids
            }, {
            fetchPolicy: 'no-cache'
        }).pipe(map(result => result.data?.deleteQuestions));
    }

    deleteSections(ids: string[]): Observable<DeleteMacroSectionsMutation['deleteMacroSections']> {
        return this.DeleteMacroSectionsGQL.mutate(
            {
                ids
            }, {
            fetchPolicy: 'no-cache'
        }).pipe(map(result => result.data?.deleteMacroSections));
    }

    createQuestions(questions: SaveEvent[]): Observable<CreateQuestionsMutation['createQuestions']> {
        const body: CreateQuestionRequest[] = questions.map(q => ({
            content: String(q?.title || q?.['content']),
            answerGroupCategoryType: MAP_QUESTION_GROUP?.[q?.type || q?.['answerGroupCategoryType']] as unknown as InputMaybe<AnswerGroupCategoryType> ?? undefined,
            macSecId: Number(q?.sectionId || q?.['macSecId']),
            questionOrder: q?.order as number || q?.['questionOrder']
        }))
        return this.CreateQuestionsGQL.mutate(
            {
                input: body
            }, {
            fetchPolicy: 'no-cache'
        }).pipe(map(result => result.data?.createQuestions));
    }

    createSections(sections: (QuestionSections & { sectionIndex: number })[]): Observable<CreateMacroSectionsMutation['createMacroSections']> {
        const body: MacroSectionInput[] = sections.map(sec => ({ description: sec.titleSection, name: sec.titleSection }));

        return this.CreateMacroSectionsGQL.mutate(
            {
                input: body
            }, {
            fetchPolicy: 'no-cache'
        }).pipe(map(result => result.data?.createMacroSections));
    }
}